import { AppLink } from '@/shared/components/AppLink';

interface RoundMenuItem {
  title: string;
  imageUrl: string;
  link: string;
  lazyload?: string;
  shouldRefresh?: boolean;
}

interface RoundMenuSectionProps {
  data: Record<string, unknown> & {
    title?: string;
    items?: RoundMenuItem[];
    blankImageUrl?: string;
  };
  sectionKey: string;
  eventLabel?: string;
  priority?: number;
}

export default function RoundMenuSection({ 
  data, 
  sectionKey: _sectionKey, 
  eventLabel: _eventLabel, 
  priority: _priority 
}: RoundMenuSectionProps) {
  const items = (data.items || []) as RoundMenuItem[];
  const title = data.title || '';

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <section className="md:hidden py-4">
      {/* Title */}
      {title && (
        <div className="container-fluid mb-4">
          <h2 className="text-base font-normal text-center leading-normal">
            <span className="font-primary text-[#9D7792]">{title}</span>
          </h2>
        </div>
      )}

      {/* Menu Items */}
      <div className="flex flex-wrap justify-center gap-[10px] px-4">
        {items.map((item, index) => {
          const isLastTwo = index >= items.length - 2;
          return (
          <div 
            key={`${item.title}-${index}`} 
            className={`${isLastTwo ? 'flex-[0_0_calc(50%-10px)]' : 'flex-[0_0_calc(33.33%-10px)]'}`}
          >
            <AppLink
              to={item.link}
              className="text-[#9D7792] text-[13px] bg-[#FCFCFB] shadow-[4px_4px_5px_0_rgba(219,183,183,0.25)] border-[0.5px] border-[#D9D9D9] p-[10px] rounded-[25px] box-border text-center flex flex-col items-center gap-2 hover:opacity-80 transition-opacity"
              eventName="Alchemy Materials Clicked"
              eventProperties={{ 'Card Name': item.title }}
              shouldRefresh={item.shouldRefresh}
            >
              {/* Round Image */}
              <img
                className="rounded-full object-cover max-h-[70px]"
                src={item.imageUrl}
                alt={item.title}
                width="auto"
                height="70"
                loading={item.lazyload ? 'lazy' : 'eager'}
                decoding="async"
              />
              
              {/* Title */}
              <h3 className="text-xs text-center font-normal text-[#9A777D] m-0">
                {item.title}
              </h3>
            </AppLink>
          </div>
          );
        })}
      </div>
    </section>
  );
}

